import AppForm from '../app-components/Form/AppForm';

Vue.component('contract-type-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                title:  null,
                shortcode: null,
                mymcd_contract_type_id: null,
                company_contract_type_id: null,
                restaurant_id: null,
                settings: {},
                intervalTypeSettings: {},
                legalChecks: {},
            }
        }
    },

    watch: {
        // The whole create form (mymcd contract types, company contract types, legal checks) depends
        // on the selected restaurant, so it is re-rendered for it. The restaurant is then submitted
        // from the form itself, not read from the current restaurant on the server.
        'form.restaurant_id': function(newVal, oldVal) {
            if (this.data && this.data.id) {
                return;
            }

            if (newVal == null || oldVal == null || newVal === oldVal) {
                return;
            }

            // stay on the same page (create or clone), only for the newly selected restaurant
            window.location.href = window.location.pathname + '?restaurant_id=' + newVal;
        }
    },

    methods: {
        goBack()
        {
            window.location.href = '/contract-types';
        },

        sanitizeDecimalPoint(val)
        {
            return (val ? val.replace(",",".") : val);
        },

        sanitizeIncorrectFloatChars(val)
        {
            val = this.sanitizeDecimalPoint(val);
            return (val ? val.replace(/[^0-9.]/,"") : val);
        },

        correctBasicInputDecimals(vmodelName,$event)
        {
            this.form.settings[vmodelName] = this.sanitizeIncorrectFloatChars($event.target.value);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/contract-type/Form.js